import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import config from 'utils/config';
import { fetchMindsetSettings } from 'actions/userProfile/useFetchUserMindsetAgent';
import createElement from 'tricks/dom/createElement';
import { getDarkerColorShadeHex } from '../ui';
import { renderMindsetSDK2 } from './renderMindsetSDK2';
import { renderMindsetSDK3 } from './renderMindsetSDK3';
// ID of the container where the Mindset SDK will be rendered
export var MINDSET_ID = 'mindset-container';
var MINDSET_SERVER_URL = 'https://mindset-prod2-eu-embedded-sdk-v3.web.app';
export var MINDSET_SDK3_URL = "".concat(MINDSET_SERVER_URL, "/mindset-sdk3.umd.js");
export var MINDSET_SDK2_URL = "https://mindset-prod2-eu-embedded-sdk.web.app/mindset-sdk2.js";
export function buildMindsetTheme(theme) {
  var cardTheme = theme.sections.card;
  var errorColor = theme.globals.colorBlocks.negative;
  var primaryButtonColor = theme.globals.buttons.primary;
  var defaultButtonColor = theme.globals.buttons.default;
  var importantButtonColor = theme.globals.buttons.important;
  var mindsetPrimaryText = theme.globals.colorBlocks.mindset;
  var mindsetPrimaryRawBg = theme.globals.colorBlocks['mindset-background'];
  var mindsetPrimaryBg = mindsetPrimaryRawBg === cardTheme.background ? getDarkerColorShadeHex(mindsetPrimaryRawBg) : mindsetPrimaryRawBg;
  var cardBgDarker = getDarkerColorShadeHex(cardTheme.background);
  return {
    brightness: 'light',
    surfaceTint: null,
    primary: mindsetPrimaryText,
    onPrimary: mindsetPrimaryBg,
    primaryContainer: mindsetPrimaryBg,
    onPrimaryContainer: mindsetPrimaryText,
    secondary: defaultButtonColor.text,
    onSecondary: defaultButtonColor.background,
    secondaryContainer: defaultButtonColor.text,
    onSecondaryContainer: defaultButtonColor.background,
    tertiary: importantButtonColor.text,
    onTertiary: importantButtonColor.background,
    tertiaryContainer: importantButtonColor.text,
    onTertiaryContainer: importantButtonColor.background,
    error: errorColor,
    onError: cardTheme.text,
    errorContainer: cardTheme.text,
    onErrorContainer: errorColor,
    background: cardTheme.background,
    onBackground: cardTheme.text,
    surface: cardTheme.background,
    onSurface: cardTheme.text,
    surfaceVariant: cardTheme.background,
    onSurfaceVariant: cardTheme.text,
    outline: cardTheme.text,
    outlineVariant: cardTheme.text,
    shadow: cardTheme.shade,
    scrim: '#000000',
    inverseSurface: cardTheme.text,
    inverseOnSurface: cardTheme.background,
    inversePrimary: primaryButtonColor.text,
    primaryFixed: primaryButtonColor.background,
    onPrimaryFixed: primaryButtonColor.text,
    primaryFixedDim: getDarkerColorShadeHex(primaryButtonColor.background),
    onPrimaryFixedVariant: primaryButtonColor.text,
    secondaryFixed: defaultButtonColor.background,
    onSecondaryFixed: defaultButtonColor.text,
    secondaryFixedDim: getDarkerColorShadeHex(defaultButtonColor.background),
    onSecondaryFixedVariant: defaultButtonColor.text,
    tertiaryFixed: importantButtonColor.background,
    onTertiaryFixed: importantButtonColor.text,
    tertiaryFixedDim: getDarkerColorShadeHex(importantButtonColor.background),
    onTertiaryFixedVariant: importantButtonColor.text,
    surfaceDim: cardBgDarker,
    surfaceBright: getDarkerColorShadeHex(cardTheme.background, 0.01),
    surfaceContainerLowest: cardBgDarker,
    surfaceContainerLow: cardBgDarker,
    surfaceContainer: cardBgDarker,
    surfaceContainerHigh: cardBgDarker,
    surfaceContainerHighest: cardBgDarker
  };
}
function domPrefetchScript(scriptURL) {
  // Prefetch the scriptURL for future navigation, if it hasn't been prefetched yet
  var prefetchedScript = document.querySelector("link[rel=prefetch][href=\"".concat(scriptURL, "\"]"));
  if (!prefetchedScript) {
    var newLink = createElement('link', {
      rel: 'prefetch',
      href: scriptURL,
      as: 'script'
    });
    document.head.appendChild(newLink);
  }
}
export function addMindsetAIIfRequired() {
  return _addMindsetAIIfRequired.apply(this, arguments);
}
function _addMindsetAIIfRequired() {
  _addMindsetAIIfRequired = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _ref,
      _ref$render,
      render,
      _ref$search,
      initialQuestion,
      appUid,
      hasMindsetSDK2,
      _yield$fetchMindsetSe,
      agentUid,
      scriptURL,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref = _args.length > 0 && _args[0] !== undefined ? _args[0] : {}, _ref$render = _ref.render, render = _ref$render === void 0 ? false : _ref$render, _ref$search = _ref.search, initialQuestion = _ref$search === void 0 ? '' : _ref$search;
          appUid = config.mindsetAppUid, hasMindsetSDK2 = config.hasMindsetSDK2;
          if (appUid) {
            _context.next = 1;
            break;
          }
          return _context.abrupt("return");
        case 1:
          _context.next = 2;
          return fetchMindsetSettings();
        case 2:
          _yield$fetchMindsetSe = _context.sent;
          agentUid = _yield$fetchMindsetSe.agentUid;
          if (agentUid) {
            _context.next = 3;
            break;
          }
          return _context.abrupt("return");
        case 3:
          if (!hasMindsetSDK2) {
            _context.next = 6;
            break;
          }
          scriptURL = MINDSET_SDK2_URL;
          if (render) {
            _context.next = 4;
            break;
          }
          domPrefetchScript(scriptURL);
          return _context.abrupt("return");
        case 4:
          _context.next = 5;
          return renderMindsetSDK2({
            scriptURL: scriptURL,
            appUid: appUid,
            initialQuestion: initialQuestion,
            agentUid: agentUid
          });
        case 5:
          _context.next = 8;
          break;
        case 6:
          if (render) {
            _context.next = 7;
            break;
          }
          domPrefetchScript(MINDSET_SDK3_URL);
          return _context.abrupt("return");
        case 7:
          _context.next = 8;
          return renderMindsetSDK3({
            appUid: appUid,
            initialQuestion: initialQuestion,
            agentUid: agentUid
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _addMindsetAIIfRequired.apply(this, arguments);
}